export default {
  site: {
    name: 'CSSSpreadsheetBR',
    tagline: 'Recurso Independente CSSBuy',
    description: 'Encontre e organize recursos do CSSBuy Spreadsheet em um so lugar. Explore links de produtos, categorias, guias de compra, QC, warehouse, frete internacional e informacoes uteis para pesquisar melhor antes de comprar.',
    title: 'CSSBuy Spreadsheet: Encontre Produtos, Links e Guias da CSSBuy',
    metaDesc: 'CSSBuy Spreadsheet: guia independente com links de produtos, categorias, avaliacoes, frete, warehouse, cupons e dicas de seguranca. Recurso em portugues para pesquisar antes de comprar.',
  },
  nav: {
    home: 'Inicio',
    shoppingGuide: 'Guia de Compras',
    spreadsheet: 'CSSBuy Spreadsheet',
    review: 'CSSBuy Review',
    shipping: 'Frete',
    coupon: 'Cupom',
    warehouse: 'Warehouse',
    legit: 'E Seguro?',
    guides: 'Guias',
    articles: 'Artigos',
    about: 'Sobre',
    contact: 'Contato',
    privacy: 'Privacidade',
    terms: 'Termos',
  },
  hero: {
    eyebrow: 'CSSBuy Spreadsheet • Guia Independente',
    h1: 'CSSBuy Spreadsheet: Encontre Produtos, Links e Guias da CSSBuy',
    description: 'Encontre e organize recursos do CSSBuy Spreadsheet em um so lugar. Explore links de produtos, categorias, guias de compra, QC, warehouse, frete internacional e informacoes uteis para pesquisar melhor antes de comprar.',
    ctaPrimary: 'Explorar CSSBuy Spreadsheet',
    ctaSecondary: 'Ver Guias CSSBuy',
    searchPlaceholder: 'Pesquise produtos, categorias ou CSSBuy Spreadsheet...',
    trust: 'Recurso independente • Conteudo em portugues • Guias atualizados • Foco em seguranca',
    ctaMainSite: 'CSSBuy Spreadsheet',
    ctaBuyNow: 'Buy It Now',
  },
  categories: {
    title: 'Categorias Populares',
    subtitle: 'Encontre os melhores produtos por categoria no CSSBuy Spreadsheet',
    shoes: 'Shoes',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
    dropdownLabel: 'Todas as Categorias',
  },
  valueProposition: {
    h2: 'Tudo o que voce precisa para explorar o CSSBuy Spreadsheet',
    spreadsheet: 'CSSBuy Spreadsheet',
    spreadsheetDesc: 'Produtos, links e categorias organizados para facilitar sua pesquisa antes de comprar.',
    guides: 'CSSBuy Guides',
    guidesDesc: 'Guias de compra, QC, warehouse e shipping para voce comprar com seguranca.',
    review: 'CSSBuy Review',
    reviewDesc: 'Informacoes e analise independente sobre o processo de compra e agentes.',
    safety: 'Safety',
    safetyDesc: 'Como verificar links, vendedores, produtos e custos antes de comprar.',
  },
  howItWorks: {
    h2: 'Como usar o CSSBuy Spreadsheet?',
    step1: 'Pesquise',
    step1Desc: 'Encontre produtos e categorias no CSSBuy Spreadsheet',
    step2: 'Verifique',
    step2Desc: 'Confira links, vendedor, produto e QC antes de comprar',
    step3: 'Compare',
    step3Desc: 'Analise opcoes, custos e informacoes para tomar a melhor decisao',
    cta: 'Explorar CSSBuy Spreadsheet',
  },
  comparison: {
    h2: 'Comparacao: O que Verificar Antes de Comprar',
    factor: 'Fator',
    whatToCheck: 'O que Verificar',
    product: 'Produto',
    productCheck: 'Link, seller e product information',
    qc: 'QC',
    qcCheck: 'Available inspection information',
    warehouse: 'Warehouse',
    warehouseCheck: 'Storage and handling',
    shipping: 'Shipping',
    shippingCheck: 'Current options and costs',
    coupon: 'Coupon',
    couponCheck: 'Expiration and eligibility',
    safety: 'Safety',
    safetyCheck: 'Verification before payment',
  },
  commercialCards: {
    h2: 'Recursos CSSBuy Mais Buscados',
    review: 'CSSBuy Review',
    reviewDesc: 'Avaliacao independente do processo, custos e confiabilidade.',
    shipping: 'CSSBuy Shipping Cost',
    shippingDesc: 'Entenda peso, dimensoes, destino, linhas de frete e consolidacao.',
    coupon: 'CSSBuy Coupon',
    couponDesc: 'Como encontrar e verificar cupons e codigos de desconto.',
    warehouse: 'CSSBuy Warehouse',
    warehouseDesc: 'Order → Seller → Warehouse → QC → Storage → Consolidation → Shipping.',
    legit: 'CSSBuy Legit',
    legitDesc: 'Avalie informacoes, pagamentos, suporte, warehouse e seguranca.',
    cta: 'Saiba Mais',
  },
  safety: {
    h2: 'Seguranca e Verificacao',
    h3: 'Como verificar antes de comprar com CSSBuy',
    description: 'Sempre verifique links, vendedores, produtos e custos antes de fazer o pagamento. O CSSBuy Spreadsheet ajuda voce a organizar e comparar informacoes para uma compra mais segura.',
    checklist1: 'Verifique o link do produto antes de comprar',
    checklist2: 'Confira avaliacoes do vendedor',
    checklist3: 'Analise fotos de QC (Quality Control)',
    checklist4: 'Compare custos de shipping para seu pais',
    checklist5: 'Verifique cupons e codigos de desconto ativos',
  },
  articles: {
    h2: 'Artigos e Guias Recentes',
    readMore: 'Ler Artigo',
    article1Title: 'CSSBuy Spreadsheet: Guia Completo',
    article1Desc: 'Tudo sobre o CSSBuy Spreadsheet, como usar, organizar links e pesquisar produtos.',
    article2Title: 'CSSBuy Shipping Cost: O que Define o Preco',
    article2Desc: 'Peso, dimensoes, destino, linha de frete e valor declarado explicados.',
    article3Title: 'Is CSSBuy Legit? Guia Pratico de Seguranca',
    article3Desc: 'Como avaliar se um produto, vendedor ou link e seguro antes de comprar.',
    article4Title: 'CSSBuy Coupon: Como Encontrar Ofertas',
    article4Desc: 'Onde buscar cupons ativos, verificar validade e aplicar descontos corretamente.',
    article5Title: 'CSSBuy Warehouse Guide: Armazenamento e Consolidacao',
    article5Desc: 'Como funciona o warehouse, o fluxo de armazenamento, consolidacao e envio internacional.',
    article6Title: 'CSSBuy QC Guide: Como Ler Fotos de Quality Control',
    article6Desc: 'O que observar nas fotos de QC para verificar qualidade antes do envio.',
    article7Title: 'CSSBuy W2C Spreadsheet: Como Encontrar Links de Produtos',
    article7Desc: 'O que significa W2C e como usar links de Taobao, Weidian e 1688 para comprar.',
    article8Title: 'CSSBuy Alternatives: Como Comparar Outros Agentes',
    article8Desc: 'Criterios para comparar CSSBuy com Superbuy, Sugargoo e outros agentes de compra.',
    article9Title: 'CSSBuy Shipping to Brazil: Frete para o Brasil',
    article9Desc: 'Regras alfandegarias, impostos, linhas de frete e consolidacao para o Brasil.',
    article10Title: 'CSSBuy Seller Verification: Verificando Vendedores',
    article10Desc: 'Sinais de vendedores confiaveis e alertas para evitar compras ruins.',
    article11Title: 'CSSBuy Parcel Consolidation: Reduza o Frete',
    article11Desc: 'Como juntar itens em um unico pacote para economizar no frete internacional.',
    article12Title: 'CSSBuy Beginner Handbook: Guia para Iniciantes',
    article12Desc: 'Tudo o que um iniciante precisa saber para comecar a comprar pelo CSSBuy.',
    article13Title: 'CSSBuy Product Research: Encontre Bons Produtos',
    article13Desc: 'Como pesquisar, comparar precos e verificar qualidade antes de comprar.',
    article14Title: 'CSSBuy Sneakers Spreadsheet: Guia de Tenis',
    article14Desc: 'Como encontrar tenis e sneakers, verificar tamanho, qualidade e preco.',
  },
  faq: {
    h2: 'Perguntas Frequentes',
    q1: 'What is CSSBuy Spreadsheet?',
    a1: 'CSSBuy Spreadsheet e um recurso organizado com links de produtos, categorias e guias para ajudar compradores a pesquisar e encontrar itens antes de comprar atraves do agente CSSBuy.',
    q2: 'How do I use CSSBuy Spreadsheet?',
    a2: 'Use a barra de pesquisa ou navegue pelas categorias para encontrar produtos. Clique nos links para verificar detalhes, vendedor e fotos de QC antes de adicionar ao carrinho.',
    q3: 'Is CSSBuy legit?',
    a3: 'CSSBuy e um agente de compras conhecido. Este site e um recurso independente para ajudar voce a verificar links, vendedores e informacoes antes de comprar.',
    q4: 'Is CSSBuy safe?',
    a4: 'A seguranca depende de verificar links, vendedores, fotos de QC e entender os custos de frete antes de pagar. Use este guia para organizar sua pesquisa.',
    q5: 'How does CSSBuy shipping work?',
    a5: 'O frete depende do peso, dimensoes, destino, linha de frete escolhida e valor declarado. Warehouse e consolidacao podem reduzir custos.',
    q6: 'How much does CSSBuy shipping cost?',
    a6: 'Os custos variam por peso, dimensoes, pais de destino, linha de frete e seguro. Consulte nossa guia completa de shipping para estimativas.',
    q7: 'What is CSSBuy QC?',
    a7: 'QC (Quality Control) sao fotos de inspecao do produto feitas no warehouse antes do envio. Elas ajudam a verificar se o item esta correto.',
    q8: 'What is CSSBuy warehouse?',
    a8: 'O warehouse e onde os produtos sao armazenados apos a compra. Inclui inspecao QC, storage e consolidacao antes do envio internacional.',
    q9: 'Where can I find CSSBuy coupons?',
    a9: 'Cupons e codigos de desconto podem ser encontrados em guias atualizados. Sempre verifique a validade e restricoes antes de usar.',
    q10: 'How do I verify CSSBuy discount codes?',
    a10: 'Verifique a data de validade, valor minimo de compra, restricoes de regiao e se o codigo ainda esta ativo antes de aplicar.',
  },
  ctaBanner: {
    h2: 'Pronto para explorar o CSSBuy Spreadsheet?',
    description: 'Continue para o site principal para encontrar mais produtos, links e recursos organizados.',
    cta: 'Continuar para o Site Principal',
    cta2: 'Buy It Now',
  },
  footer: {
    tagline: 'Recurso independente sobre CSSBuy Spreadsheet. Nao somos afiliados nem endossados pela CSSBuy.',
    links: 'Links Uteis',
    legal: 'Legal',
    resources: 'Recursos',
    about: 'Sobre',
    editorial: 'Editorial Policy',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    spreadsheet: 'CSSBuy Spreadsheet',
    review: 'CSSBuy Review',
    shipping: 'Frete',
    coupon: 'Cupom',
    warehouse: 'Warehouse',
    legit: 'E Seguro?',
    articles: 'Artigos',
    safety: 'Seguranca',
    copyright: 'CSSSpreadsheetBR. Recurso independente. Nao afiliado a CSSBuy.',
  },
  breadcrumb: {
    home: 'Inicio',
  },
  notFound: {
    title: 'Pagina nao encontrada',
    description: 'A pagina que voce procura nao existe. Volte para a pagina inicial e continue explorando o CSSBuy Spreadsheet.',
    cta: 'Voltar ao Inicio',
  },
  general: {
    lastUpdated: 'Atualizado em',
    readTime: 'min de leitura',
    quickAnswer: 'Resposta rapida:',
    checklist: 'Checklist',
    relatedArticles: 'Artigos Relacionados',
    tableOfContents: 'Conteudo',
    share: 'Compartilhar',
    author: 'Autor',
    editor: 'Editor',
    disclaimer: 'Este site e um recurso independente e nao e afiliado nem endossado pela CSSBuy. As informacoes sao fornecidas para fins de pesquisa e organizacao.',
  },
  schema: {
    organization: 'CSSSpreadsheetBR',
    organizationDesc: 'Recurso independente sobre CSSBuy Spreadsheet, produtos, links e guias de compra.',
    faqPage: 'Perguntas Frequentes sobre CSSBuy Spreadsheet',
  },
  products: {
    eyebrow: 'Explore Produtos',
    title: 'Produtos em Destaque',
    description: 'Navegue pelos produtos curados do CSSBuy Spreadsheet. Clique em qualquer item para ver detalhes e comprar no site principal.',
    viewAll: 'Ver Todos',
    buy: 'Comprar',
    noProducts: 'Produtos em breve',
  },
};